module.exports = __webpack_public_path__ + "img/18.02ff9aa8.png";